"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactComponents = require("@cimpress/react-components");

var AsyncImage =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(AsyncImage, _PureComponent);

  function AsyncImage() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, AsyncImage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(AsyncImage)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      imgLoaded: false,
      imgLoading: true,
      timedOut: false
    };

    _this.onImgLoad = function () {
      _this.setState({
        imgLoading: true,
        imgLoaded: true
      });
    };

    return _this;
  }

  (0, _createClass2.default)(AsyncImage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.src) {
        clearTimeout(this.timer);
        setTimeout(function () {
          return _this2.setState({
            timedOut: true
          });
        }, this.props.timeoutMs);
      } else {
        this.setState({
          timedOut: true
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;

      var src = this.props.src;

      if (src !== prevProps.src) {
        this.setState({
          imgLoading: true,
          imgLoaded: false,
          timedOut: false
        }, function () {
          return setTimeout(function () {
            return _this3.setState({
              timedOut: true
            });
          }, _this3.props.timeoutMs);
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          src = _this$props.src,
          alt = _this$props.alt,
          width = _this$props.width,
          height = _this$props.height,
          timeoutMs = _this$props.timeoutMs,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["src", "alt", "width", "height", "timeoutMs"]);
      var _this$state = this.state,
          imgLoaded = _this$state.imgLoaded,
          imgLoading = _this$state.imgLoading,
          timedOut = _this$state.timedOut;
      var widthPx = "".concat(width, "px");
      var heightPx = "".concat(height, "px");
      var containerStyle = {
        width: widthPx,
        height: heightPx
      };
      var spinnerContainerStyle = {
        height: heightPx,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      };
      var spinnerSize = Math.min(width, height) / 2;
      return _react.default.createElement("div", {
        className: "async-image",
        style: containerStyle
      }, imgLoading && !imgLoaded && !timedOut ? _react.default.createElement("div", {
        className: "async-image__spinner",
        style: spinnerContainerStyle
      }, _react.default.createElement(_reactComponents.shapes.Spinner, {
        size: spinnerSize,
        style: {
          height: "".concat(spinnerSize, "px")
        }
      })) : null, _react.default.createElement("img", Object.assign({
        src: src || '',
        alt: alt,
        width: widthPx,
        height: heightPx,
        onLoad: this.onImgLoad
      }, rest)));
    }
  }]);
  return AsyncImage;
}(_react.PureComponent);

AsyncImage.defaultProps = {
  alt: '',
  width: 50,
  height: 50,
  timeoutMs: 5000
};
var _default = AsyncImage;
exports.default = _default;